import styled from 'react-emotion';
import { space, color, width } from 'styled-system';
import { bouncyBoyMixin } from '../../styles';

export const ViewWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;

export const ViewLayout = styled('div')`
  float: left;
  width: 3vw;
  height: 3vw;
  border-radius: 5px;
  ${space}
  ${color}
  margin-left: 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-direction: column;
  ${bouncyBoyMixin}
  padding: 0.25vw;
`;

export const Column = styled('div')`
  ${width}
  ${space}
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 0.05vw;
  padding-right: 0.05vw;
`;

export const Row = styled('div')`
  ${space}
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  height: ${props => `${props.height * 100}%`};
`;

export const Box = styled('div')`
  ${width}
  ${space}
  height: 100%;
  width: 100%;
  background: #fff;
  border-radius: .05em;
  margin-top: 0.06vw;
  margin-bottom: 0.06vw;
`;
